function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "awesome-twitter",
  "data-name": "Icon awesome-twitter",
  d: "M60.162,17.173c.043.605.043,1.211.043,1.816,0,18.462-13.828,39.734-39.1,39.734A38.387,38.387,0,0,1,0,52.454a27.98,27.98,0,0,0,3.319.173A27.245,27.245,0,0,0,20.38,46.661,13.8,13.8,0,0,1,7.531,36.976a17.06,17.06,0,0,0,2.6.216,14.316,14.316,0,0,0,3.616-.476A13.913,13.913,0,0,1,2.723,23.01v-.173A13.674,13.674,0,0,0,8.935,24.61,14.136,14.136,0,0,1,4.68,5.932,38.861,38.861,0,0,0,33.016,20.546a16.011,16.011,0,0,1-.34-3.2A13.849,13.849,0,0,1,46.419,3.381,13.609,13.609,0,0,1,56.46,7.791a26.8,26.8,0,0,0,8.722-3.372,13.889,13.889,0,0,1-6.042,7.7,27.2,27.2,0,0,0,7.914-2.162,29.807,29.807,0,0,1-6.892,7.22Z",
  transform: "translate(0 -3.381)",
  fill: "#fff"
});

var SvgAwesomeTwitter = function SvgAwesomeTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 67.054 55.343",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwesomeTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/awesome-twitter.4f17294d.svg";
export { ForwardRef as ReactComponent };